// extracted by mini-css-extract-plugin
export default {"buyerUpdate":"Ly2o9VE8ijiCV7_Z65su__buyerUpdate___","container":"Ipw0LLeLYj1N3MVwz_pe__container___"};